import { Protocol } from './index';
import { Category } from '../constants';

const social: Protocol[] = [
  {
    name: 'Builder.fi',
    url: 'https://www.builder.fi/',
    logoPath: '/logos/builder.fi.jpg',
    category: Category.Social,
    twitterUrl: 'https://twitter.com/talentprotocol',
  },
  {
    name: 'Circle.tech',
    url: 'https://circle.tech/',
    logoPath: '/logos/circle.tech.jpg',
    category: Category.Social,
    twitterUrl: 'https://twitter.com/teamcircletech',
  },
  {
    name: 'Collab.land',
    url: 'https://www.collab.land/',
    logoPath: '/logos/collab.land.jpg',
    category: Category.Social,
    twitterUrl: 'https://twitter.com/Collab_Land_',
  },
  {
    name: 'Cyberconnect',
    url: 'https://cyberconnect.me/',
    logoPath: '/logos/cyberconnect.jpg',
    category: Category.Social,
    twitterUrl: 'https://twitter.com/CyberConnectHQ',
  },
  {
    name: 'Friend.tech',
    url: 'https://www.friend.tech/',
    logoPath: '/logos/friend.tech.jpg',
    category: Category.Social,
    twitterUrl: 'https://twitter.com/friendtech',
  },
  {
    name: 'Mirror',
    url: 'https://www.mirror.xyz/',
    logoPath: '/logos/mirror.jpg',
    category: Category.Social,
    twitterUrl: 'https://twitter.com/viamirror',
  },
  {
    name: 'Tally',
    url: 'https://www.tally.xyz/',
    logoPath: '/logos/tally.jpg',
    category: Category.Social,
    twitterUrl: 'https://twitter.com/tallyxyz',
  },
];
export { social };
